{
  "labels": {
    "new_project": "Neues Projekt",
    "organization": "Organisation",
    "private": "Privat",
    "select_department": "Abteilung auswählen",
    "cancel": "Abbrechen",
    "organizations": "Organisationen",
    "departments": "Abteilungen",
    "select_organization_from_left": "Wählen Sie eine Organisation aus",
    "org_does_not_have_deps": "Diese Organisation hat noch keine Abteilungen",
    "select_department_modal_title": "Wählen Sie eine Abteilung aus",
    "this_project_belongs_to": "Dieses Projekt gehört zu"
  },
  "input_labels": {
    "name": "Name",
    "description": "Beschreibung"
  },
  "templates": {
    "add_to_organization": "In {{organization}} erstellen"
  },
  "validation": {
    "name": {
      "empty": "Geben Sie den Namen des Projekts ein",
      "duplicate_name": "Dieser Name ist bereits vergeben",
      "min_length": "Der Name darf nicht kürzer als {{minLength}} Zeichen sein",
      "max_length": "Der Name darf nicht länger als {{maxLength}} Zeichen sein",
      "invalid": "Der Name muss mit einem Buchstaben beginnen und mit einem Buchstaben oder einer Ziffer enden. Er darf Leerzeichen, Punkte und Bindestriche enthalten."
    },
    "description": {
      "max_length": "Die Beschreibung darf nicht länger als 200 Zeichen sein",
      "empty": "Geben Sie eine Beschreibung ein"
    },
    "department": {
      "empty": "Wählen Sie eine Abteilung aus.."
    }
  },
  "buttons": {
    "previous": "Zurück",
    "next": "Weiter",
    "create": "Erstellen"
  }
}
